
import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import notify from 'devextreme/ui/notify';
import Button from 'devextreme-react/button';
import html2pdf from 'html2pdf.js';
import Axios from '../api/axios';

export default function GuestSignPage() {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [docHtml, setDocHtml] = useState('');
  const [signed, setSigned] = useState(false);
  const [saving, setSaving] = useState(false);
  const [signData, setSignData] = useState(null);
  const signRef = useRef(null);

  useEffect(() => {
    // Token doğrulama (GET) ve doküman çekme
    Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}guest-sign/verify?token=${token}`)
      .then(res => {
        if (res.data && res.data.documentId && res.data.carRef) {
          if (res.data.documentHtml) {
            setDocHtml(res.data.documentHtml);
            setLoading(false);
            return;
          }
          // Doküman HTML'ini backend'den çek
          Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}sablonops/getSablonHtml?SAB_REF=${res.data.documentId}&CAR_REF=${res.data.carRef}`)
            .then(docRes => {
              if (docRes.data && docRes.data.length > 0) {
                setDocHtml(docRes.data[0].SAB_HTML);
              } else {
                setError('Doküman bulunamadı.');
              }
              setLoading(false);
            })
            .catch(() => {
              setError('Doküman yüklenemedi.');
              setLoading(false);
            });
        } else {
          setError('Geçersiz veya süresi dolmuş link.');
          setLoading(false);
        }
      })
      .catch(() => {
        setError('Link doğrulanamadı.');
        setLoading(false);
      });
  }, [token]);

  const handleSign = () => {
    // Basit imza: mouse ile çizim (canvas)
    setSignData(null); // imza alanını aç
  };

  const handleSave = async () => {
    if (!signRef.current || saving) return;
    setSaving(true);
    const canvas = signRef.current;
    const signature = canvas.toDataURL('image/png');
    // PDF oluştur ve backend'e gönder
    const element = document.createElement('div');
    element.innerHTML = docHtml + `<br/><img src='${signature}' style='max-width:300px;' />`;
    const pdfBlob = await html2pdf().from(element).outputPdf('blob');
    const formData = new FormData();
    formData.append('token', token);
    formData.append('pdf', pdfBlob, 'signed.pdf');
    try {
      await Axios.post(`${process.env.REACT_APP_BACKEND_SERVER}guest-sign/submit`, formData);
      setSigned(true);
      notify('İmzalı doküman başarıyla kaydedildi.', 'success', 2000);
    } catch (err) {
      notify(err?.response?.data?.message || 'Kaydetme başarısız.', 'error', 3000);
    } finally {
      setSaving(false);
    }
  };

  // Basit canvas imza alanı
  const renderSignaturePad = () => (
    <canvas
      ref={signRef}
      width={300}
      height={100}
      style={{ border: '1px solid #888', background: '#fff' }}
      onMouseDown={startDraw}
      onMouseMove={draw}
      onMouseUp={endDraw}
      onMouseLeave={endDraw}
    />
  );

  // Canvas çizim fonksiyonları
  let drawing = false;
  function startDraw(e) {
    drawing = true;
    const ctx = signRef.current.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
  }
  function draw(e) {
    if (!drawing) return;
    const ctx = signRef.current.getContext('2d');
    ctx.lineTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    ctx.stroke();
  }
  function endDraw() {
    drawing = false;
  }

  if (loading) return <div>Yükleniyor...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (signed) return <div>İmzalama tamamlandı. Teşekkürler!</div>;

  return (
    <div style={{ maxWidth: 700, margin: '40px auto', background: '#f9f9f9', padding: 24, borderRadius: 8 }}>
      <div dangerouslySetInnerHTML={{ __html: docHtml }} />
      <h3>İmzanızı ekleyin:</h3>
      {renderSignaturePad()}
      <div style={{ marginTop: 16 }}>
        <Button text={saving ? 'Kaydediliyor…' : 'İmzala ve Kaydet'} type="success" disabled={saving} onClick={handleSave} />
      </div>
    </div>
  );
}
